import { Box, Typography } from "@mui/material";
import { SxProps, Theme } from "@mui/system";
import styles from "./FooterComponent.module.scss";
import { useTranslation } from "react-i18next";

const FooterComponent: React.FC<{
  backgroundColor?: string;
  height?: string;
  sx?: SxProps<Theme>;
}> = ({ backgroundColor, height, sx }) => {
  const { t } = useTranslation();
  const currentYear: number = new Date().getFullYear();
  return (
    <footer>
      <Box
        sx={{
          backgroundColor: { backgroundColor },
          height: { md: height || "0px" },
          ...sx,
        }}
        className={styles.footerContainer}
      >
        <Box className={styles.footerContent}>
          <Typography variant="body2" component="h4" fontWeight="300" mb={1}>
            {t("footerDescription")}
          </Typography>
          <Typography variant="body2" component="h4" fontWeight="300">
            {t("footerCopyrightDescription", { year: currentYear })}
          </Typography>
        </Box>
      </Box>
    </footer>
  );
};

export default FooterComponent;
